import { type ReactElement } from "react";
import { Text, Stack, Card, CardContent } from "@citibox-panel/ui";

export function CardDemo(): ReactElement {
  return (
    <Stack direction="row" spacing={2}>
      <Card variant="outlined" sx={{ maxWidth: 280 }}>
        <CardContent>
          <Text variant="h6" component="h3" gutterBottom>
            Outlined
          </Text>
          <Text variant="body2" color="secondary">
            Card con borde y contenido en CardContent.
          </Text>
        </CardContent>
      </Card>
      <Card sx={{ maxWidth: 280 }}>
        <CardContent>
          <Text variant="h6" component="h3" gutterBottom>
            Elevation
          </Text>
          <Text variant="body2" color="secondary">
            Card con elevación por defecto.
          </Text>
        </CardContent>
      </Card>
    </Stack>
  );
}
